import { render, staticRenderFns } from "./infoTiers.vue?vue&type=template&id=2c31fe14&scoped=true&"
import script from "./infoTiers.vue?vue&type=script&lang=js&"
export * from "./infoTiers.vue?vue&type=script&lang=js&"
import style1 from "./infoTiers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c31fe14",
  null
  
)

export default component.exports